export default __webpack_public_path__ + "static/media/element_spec_54.847a7287.jpg";